/* CivicOS phone themes — swappable skins earned in the SpecStore. Applied as a
   display filter on the whole handset screen (same mechanism as client mod packs),
   so every app — mail, bank, Ghostwire — re-skins consistently with zero per-app work. */

export const PHONE_THEMES = {
  stock:    { label: "CivicOS Dark",  cost: 0,   desc: "The stock night skin. Ships with every handset." },
  contrast: { label: "High-Contrast", cost: 0,   desc: "Stark monochrome, maximum legibility. Free — accessibility is a right." },
  stealth:  { label: "Stealth Dark",  cost: 150, desc: "Deep black, low glow. For citizens who don't like being seen." },
  light:    { label: "Light Mode",    cost: 300, desc: "Daylight-bright CivicOS. Braver than most criminals." },
};

/* filter recipes — invert+hue-rotate turns the dark UI light while keeping accent hues */
export const THEME_FILTERS = {
  stock: "",
  contrast: "grayscale(1) contrast(1.55) brightness(1.06)",
  stealth: "brightness(0.72) contrast(1.25) saturate(0.85)",
  light: "invert(0.92) hue-rotate(180deg)",
};
